export * from './hexagon-badge';

//# sourceMappingURL=index.js.map